export default "__VITE_ASSET__64c125b4__"